import { Component, Input } from '@angular/core';
import { config } from "rxjs";

@Component({
  selector: 'app-unordered-list',
  templateUrl: './unordered-list.component.html',
  styleUrls: ['./unordered-list.component.scss']
})
export class UnorderedListComponent {
  @Input() listItem: string[] = [];
}
